module.exports = __webpack_public_path__ + "img/avatarAdmin.c689bfc4.png";